import React from 'react';

import { isTabletOrWeb } from 'utils/responsiveness';

import RecordingActionsDropDown from './RecordingActionsDropDown';
import RecordingActionsOverlay from './RecordingActionsOverlay';
import { IProps } from './types';

function SelectRecordingActions(props: IProps) {
    const Selector = isTabletOrWeb
        ? RecordingActionsDropDown
        : RecordingActionsOverlay;

    return <Selector {...props} />;
}

export default React.memo(SelectRecordingActions);
